import Mock from './mock';
import { getEnv } from 'ecx.saigon.ui.common';
import { getBudgetSummary as query } from '../graphql/budget';
import apolloClient from '../../utils/apollo-client';

export default async function (leaseId) {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return await new Promise((resolve) =>
      setTimeout(() => resolve(Mock.data.getBudgetSummary), 1000)
    );
  }

  const response = await apolloClient().then((client) =>
    client.query({
      query,
      variables: { leaseId }
    })
  );
  return response.data.getBudgetSummary;
}
